


input.textInput {
  border-radius: var(--border-radius);
  border: 1px solid var(--beigedark) !important;
  width: auto;
  display: block;
  background: white;
  padding: 0.5rem 0.75rem;

  &[readonly], &[disabled] {
    background: var(--color-disabled);
  }

  &.small {
    font-size: 0.875rem;
    padding: 0.25rem;
  }

  &.large {
    font-size: 1.25rem;
    padding: 0.75rem;
  }

  &.fullWidth {
    width: 100%;
  }

}